import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import axiosInstance from '../axiosConfig';
import './EntityModals.css';

function ProjectModal({ show, handleClose, onSubmit }) {
    const [formData, setFormData] = React.useState({
        name: '',
        description: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();

        // Используем FormData для правильной передачи данных
        const data = new FormData();
        data.append('name', formData.name);
        data.append('description', formData.description);

        axiosInstance.post('/api/create_project/', data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(response => {
            if (response.data.success) {
                onSubmit(response.data);
                setFormData({ name: '', description: '' });
                handleClose();
            } else {
                console.error('Ошибка при создании проекта:', response.data.errors);
            }
        })
        .catch(error => {
            console.error('Ошибка при создании проекта:', error);
        });
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            centered
            className="entity-modal"
            dialogClassName="entity-modal-dialog entity-modal-dialog--sm"
            contentClassName="entity-modal-content"
        >
            <Modal.Header closeButton>
                <Modal.Title>Добавить проект</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleFormSubmit} className="entity-form">
                    <Form.Group controlId="formName" className="entity-field">
                        <Form.Label className="entity-label">Название</Form.Label>
                        <Form.Control
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>
                    <Form.Group controlId="formDescription" className="entity-field">
                        <Form.Label className="entity-label">Описание</Form.Label>
                        <Form.Control
                            as="textarea"
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                        />
                    </Form.Group>
                    <div className="entity-actions">
                        <Button className="entity-btn entity-btn-primary" type="submit">
                            Сохранить
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
}

export default ProjectModal;
